import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { ReplaySubject, Subject, take } from "rxjs";

import {
  Component,
  ComponentRef,
  ElementRef,
  HostBinding,
  OnDestroy,
  OnInit,
  Type,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";

@Component({
  selector: "golden-layout-item-container-content",
  template: `<ng-container #content></ng-container>`,
  styles: [],
  standalone: false,
})
export class GoldenLayoutItemContainerContent<T> implements OnInit, OnDestroy {
  @HostBinding("class.lm_content")
  lmContent = true;

  @ViewChild("content", { read: ViewContainerRef, static: true })
  private _contentViewContainerRef: ViewContainerRef;

  private _componentRef: ComponentRef<T>;

  private _onInit: Subject<void> = new ReplaySubject<void>(1);

  constructor(
    private elementRef: ElementRef,
    private viewContainerRef: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this._onInit.next();
  }

  ngOnDestroy(): void {
    if (this._onInit != null && !this._onInit.closed) {
      this._onInit.complete();
    }
  }

  createComponent(componentType: Type<T>): ComponentRef<T> {
    // create in available viewContainerRef
    this._componentRef = this.viewContainerRef.createComponent(componentType);

    this._onInit.pipe(take(1)).subscribe(() => {
      // after view init is complete move to content 's view ref
      let index = this.viewContainerRef.indexOf(this._componentRef.hostView);
      let viewRef = this.viewContainerRef.detach(index);
      this._contentViewContainerRef.insert(viewRef);
    });

    // need to return this sync for golden-layout constructors
    return this._componentRef;
  }

  getElement(): Node {
    return this.elementRef.nativeElement;
  }
}
